module.exports = __webpack_public_path__ + "media/images/icons/twotone/save-ed539004d4c6ab5eb5053ea159fccf4c.svg";